import * as Sentry from '@sentry/react'
import { getEnv } from '../utils/common'

export const FIRMWARE_VERSION_TAG = 'firmware_version'
export const DEVICE_NAME_TAG = 'device_name'

let consentGranted = false

// For a detailed description of each configuration option, see the Sentry documentation:
// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#core-options
Sentry.init({
  environment: getEnv().toString(),
  dsn: 'https://b9bb36f44ea32026aba858bb72335fba@o4511372355567616.ingest.us.sentry.io/4511372359958528',
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] })
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost'],
  enableLogs: true,
  ignoreErrors: ['InvalidStateError', /An operation that changes the device state/],
  beforeSend: (event) => (consentGranted ? event : null)
})

export function grantSentryConsent() {
  consentGranted = true
}

export function revokeSentryConsent() {
  consentGranted = false
}
